import store from "../store";
const Auth = {
  getAuth() {
    const state = store.getState();
    return !!state.auth.login?.auth_token;
  }
};
export default Auth;
